module.exports = __webpack_public_path__ + "img/base_front.7f2a0e74.jpeg";